/** sessionStorage: voorkomt eindeloze reload-loop als recovery faalt */
export const CHUNK_RECOVERY_STORAGE_KEY = 'salon_app_chunk_recovery_reload_at'

export function isStaleAppBundleLoadError (error: unknown): boolean {
  if (!(error instanceof Error)) return false
  const { message, name } = error
  if (name === 'ChunkLoadError') return true
  if (/Failed to fetch dynamically imported module/i.test(message)) return true
  if (/Importing a module script failed/i.test(message)) return true
  if (/error loading dynamically imported module/i.test(message)) return true
  return false
}

/** True als we nog geen recovery-reload deden, of de vorige poging lang genoeg geleden is */
export function shouldAttemptChunkRecoveryReload (): boolean {
  try {
    const raw = sessionStorage.getItem(CHUNK_RECOVERY_STORAGE_KEY)
    if (!raw) return true
    const last = Number(raw)
    if (Number.isNaN(last)) return true
    return Date.now() - last > 8000
  } catch {
    return true
  }
}

export function markChunkRecoveryReloadAttempt (): void {
  try {
    sessionStorage.setItem(CHUNK_RECOVERY_STORAGE_KEY, String(Date.now()))
  } catch {
    /* private mode / quota */
  }
}

export function clearChunkRecoveryReloadMarker (): void {
  try {
    sessionStorage.removeItem(CHUNK_RECOVERY_STORAGE_KEY)
  } catch {
    /* */
  }
}
